import { render, staticRenderFns } from "./KidsProductImages.vue?vue&type=template&id=025a786f&scoped=true"
import script from "./KidsProductImages.vue?vue&type=script&lang=js"
export * from "./KidsProductImages.vue?vue&type=script&lang=js"
import style0 from "./KidsProductImages.vue?vue&type=style&index=0&id=025a786f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025a786f",
  null
  
)

export default component.exports